import Sparkles from "../../loaders/Sparkles";

interface CoachLoadingStateProps {
  themeColor?: string;
}

export default function CoachLoadingState({ themeColor }: CoachLoadingStateProps) {
  return (
    <div className="flex flex-col items-center py-10 gap-5">
      <Sparkles
        color={themeColor ?? "currentColor"}
        size={48}
        duration={2.1}
        title="Preparing your coaching brief"
      />

      <p className="text-sm font-medium text-slate-500 tracking-wide">
        Preparing your coaching brief…
      </p>
    </div>
  );
}
